module.exports = __webpack_public_path__ + "ov_8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/contact/ov/ov_8.jpg
// module id = 879
// module chunks = 0